import AtendimentoVistoriaEntregaChaves from "../../AtendiementoVistoriaEntregaChaves";

export function FilaAtendimentoVistoria() {
    return <AtendimentoVistoriaEntregaChaves atendimento="GRUPO" />;
}
